/** Property-chat visitor session id, persisted per property token. */

function storageKey(token: string): string {
  return `meshcore-visitor:${token}`;
}

export function readStoredVisitorId(token: string): string | null {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(storageKey(token));
}

export function writeStoredVisitorId(token: string, visitorId: string): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(storageKey(token), visitorId);
}

export function clearStoredVisitorId(token: string): void {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(storageKey(token));
}
